import script from "./VLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./VLink.vue?vue&type=script&setup=true&lang=ts"

import "./VLink.vue?vue&type=style&index=0&id=7dad2252&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dad2252"]])

export default __exports__